var aiMergeTagKey = function (mergeTag) {
  if (!mergeTag) return null;
  var aiMatch = String(mergeTag).match(/ai\.([a-zA-Z0-9_]+)/);
  if (aiMatch) return aiMatch[1];
  var cleaned = String(mergeTag)
    .replace(/[{}()]/g, "")
    .trim();
  return cleaned || null;
};

var option = (value, label) => ({ value, label });
var advanced = (options) => options.map((o) => ({ ...o, advanced: true }));

var customFieldSlugs = function (website, fields) {
  var slugs = [
    ...Object.values(website?.fields || {}),
    ...Object.values(fields || {}),
  ]
    .map((field) => field?.slug)
    .filter((slug) => slug && slug.indexOf("survey_") === -1);
  return Array.from(new Set(slugs)).sort();
};

var aiContentKeys = function (actions) {
  var keys = Object.values(actions || {})
    .filter(
      (action) =>
        action &&
        action.toBeDeleted !== true &&
        action.action_type === "Generate AI content"
    )
    .map((action) => aiMergeTagKey(action.data?.merge_tag))
    .filter(Boolean);
  return Array.from(new Set(keys)).sort();
};

export function buildMergeTagGroups({
  website = null,
  fields = null,
  actions = null,
} = {}) {
  var groups = [
    {
      label: "Contact",
      options: [
        option("({person.firstname} OR {fallback=friend})", "First Name"),
        option("({person.lastname} OR {fallback=})", "Last Name"),
        option("({person.email} OR {fallback=})", "Email"),
        option("({person.phone} OR {fallback=})", "Phone"),
        option("({person.website} OR {fallback=})", "Website"),
        option("({person.company_name} OR {fallback=})", "Company Name"),
        option("({person.company_title} OR {fallback=})", "Company Title"),
        option("({person.city} OR {fallback=})", "City"),
        option("({person.country} OR {fallback=})", "Country"),
        option("({person.address} OR {fallback=})", "Address"),
        option("({person.state} OR {fallback=})", "State"),
        option("({person.zipcode} OR {fallback=})", "Zip Code"),
        option("({CURRENT_SCORE})", "Current Score"),
      ],
    },
    {
      label: "Custom Fields",
      chipPrefix: "Field",
      options: customFieldSlugs(website, fields).map((slug) =>
        option("({person.field_labels." + slug + "} OR {fallback=})", slug)
      ),
    },
    {
      label: "Cart",
      options: [
        option("({cart.value})", "Value"),
        option("({cart.value_threshold})", "Offer Threshold"),
        option("({cart.value_threshold_gap})", "Offer Threshold Gap"),
        option("({cart.count} OR {fallback=0})", "Item Count"),
      ],
    },
    {
      label: "Product",
      options: advanced([
        option("({product.title} OR {fallback=Product Title})", "Title"),
        option("({product.type} OR {fallback=Product Type})", "Type"),
        option("({product.price} OR {fallback=0})", "Price"),
        option(
          "({product.compare_at_price} OR {fallback=0})",
          "Compare At Price"
        ),
        option(
          "({product.description} OR {fallback=Description})",
          "Description"
        ),
        option(
          "({collection.title} OR {fallback=Collection Title})",
          "Collection Title"
        ),
      ]),
    },
    {
      label: "Page",
      options: advanced([
        option("({parameter=PARAMETER} OR {fallback=})", "URL Parameter"),
        option("({window.variable} OR {fallback=})", "Global Variable"),
      ]),
    },
    {
      label: "AI Content",
      chipPrefix: "AI",
      options: advanced(
        aiContentKeys(actions).map((key) =>
          option("({ai." + key + "} OR {fallback=})", key)
        )
      ),
    },
  ];

  return groups.filter((group) => group.options.length > 0);
}

export { aiMergeTagKey };
